import {LabelStock} from "./label.style";
import React from "react";
import {useDispatch} from "react-redux";
import {setStockLabelLayer} from "../libs/action";

export default function StockLabelComponent({isShow, labelWidth, labelHeight}) {

    const dispatch = useDispatch();

    const onClickStockLabel = () => {
        dispatch(setStockLabelLayer(true))
    }

    return(
        <LabelStock
            isShow={isShow}
            labelWidth={labelWidth}
            labelHeight={labelHeight}
            onClick={onClickStockLabel}
        >
            재고인증
        </LabelStock>
    )
}



// WEBPACK FOOTER //
// ./src/estimate_list/common/stockLabel.js